import { VacationsApplication } from 'features/vacations-application/VacationsApplication';
import { useTitle } from '../helpers';

/**
 * @page Vacations
 */
const VacationsApplicationPage = () => {
  useTitle('Отпуск');

  return (
    <div>
      <VacationsApplication />
    </div>
  );
};

export default VacationsApplicationPage;
